import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IFavoriteParams } from '~src/spacesPlatform/utils/actionParams';

export let ViewedObjectType = {
  Metric: 'metric',
  Collection: 'collection'
};

export interface IMarkViewedParams {
  objectId: string;
  objectType: string;
}

export class MarkViewedRequest extends Request<IMarkViewedParams, IResult> {
  constructor(params: IFavoriteParams) {
    super('markViewed', params);
  }
}
